export const maxNumberInputLength = 15;
export const maxPriceAfterPointLength = 2;

export const simpleNumberValidator = (value: string) =>
  /^-?((0|[1-9]\d*)([.,]\d*)?)?$/.test(value) && value.replace(/(^-)|((?!\.).$)/g, '').length < maxNumberInputLength;

export const numberFieldPrepareMutator = (value: string) => value.replace(',', '.').replace(/^(-?)0+(\d)/g, '$1$2');

export const priceProps = { afterDecimalPointLimit: maxPriceAfterPointLength, minValue: 0 };
